<template>
    <font-awesome-icon v-if="isLoading" icon="spinner" spin/>
    <span v-else-if="isError" class="font-italic">
        <span class="text-danger">Fout bij het ophalen</span>
        <b-button variant="link" size="sm" @click="loadSupplyChain" class="ml-2"><font-awesome-icon icon="rotate"/></b-button>
    </span>
    <span v-else-if="supplyChain">
        {{ supplyChain }}
    </span>
    <i v-else>
        geen ruleset gekoppeld
    </i>
</template>

<script>
import axios from "axios";

export default {
    name: "ProductInfoSupplyChain",

    props: {
        productIdentifier: {required: true, type: String},
    },

    data() {
        return {
            isLoading: true,
            isError: false,
            supplyChain: null,
        }
    },

    mounted() {
        this.loadSupplyChain()
    },

    methods: {
        loadSupplyChain() {
            this.isLoading = true;
            axios.get(`/api/proxy/sle/api/products/${this.productIdentifier}`, {
                params: {
                    include: 'ruleset',
                },
            })
                .then(response => {
                    this.supplyChain = response.data.ruleset?.identifier ?? ''
                })
                .catch(() => {
                    this.isError = true;
                })
                .then(() => this.isLoading = false)
        }
    },
}
</script>
